import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "gatsby-plugin-intl";

const IconedList = ({ data }) => (
  <>
    {data.map(({ intlTitle, icon, intlListItems = [], key }) => (
      <dl className="mb-8" key={intlTitle || key}>
        {intlTitle && (
          <dt className="text-2dot5xl font-semibold mb-4 ">
            <FormattedMessage id={intlTitle} />
          </dt>
        )}
        {intlListItems.map(intlId => (
          <dd
            className="text-md flex flex-row flex-start justify-start items-center mb-4"
            key={intlId}
          >
            <img
              src={icon}
              alt="icon"
              className="mx-0 mr-8  md:mx-8 rtl:mr-0 rtl:ml-8 md:rtl:mx-8"
            />
            <span>
              <FormattedMessage id={intlId} />
            </span>
          </dd>
        ))}
      </dl>
    ))}
  </>
);

IconedList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      intlTitle: PropTypes.string,
      intlListItems: PropTypes.arrayOf(PropTypes.string),
      key: PropTypes.string,
    })
  ),
};

export default IconedList;
